import { createClient } from '@/shared/api';
import type {
  CreateShipmentLabelMutation,
  CreateShipmentLabelMutationVariables,
} from '@/shared/api';
import CREATE_SHIPMENT_LABEL from '../mutations/createShipmentLabel';

/**
 * Requests a carrier shipping label for an RMA shipment. Runs CREATE_SHIPMENT_LABEL and throws the returned message when isSuccess is false, otherwise returning the whole createShipmentLabel payload.
 *
 * @param input - Mutation input payload.
 * @returns The created shipment label payload.
 */
const handleCreateShipmentLabel = async (
  input: CreateShipmentLabelMutationVariables['input'],
): Promise<NonNullable<CreateShipmentLabelMutation['createShipmentLabel']>> => {
  const client = createClient();
  const result = await client.mutate<
    CreateShipmentLabelMutation,
    CreateShipmentLabelMutationVariables
  >({
    mutation: CREATE_SHIPMENT_LABEL,
    variables: {
      input,
    },
  });
  // client.mutate's default errorPolicy throws before this line on any GraphQL error, so data is always present here.
  const { createShipmentLabel } = result.data!;
  const { isSuccess, message } = createShipmentLabel!;
  if (!isSuccess) {
    throw new Error(message ?? undefined);
  } else return createShipmentLabel;
};

export default handleCreateShipmentLabel;
